/**
 * Created by lxhfight on 2018/4/3.
 * Email: lxhfight1@gmail
 * Description:
 *  包含登錄和註冊接口
 */

import { doPost, DEVICE_UUID, doGet } from '../../tools/axios'
import { PLATFORM } from '../../tools/AppConfig'

export default {
  login (bundle, cb) {
    return doPost(`/user/login`, {
      ...bundle,
      uuid: DEVICE_UUID,
      platform: PLATFORM
    }, cb)
  },
  phoneLogin (bundle, cb) {
    return doPost(`/phone/login`, {
      ...bundle,
      uuid: DEVICE_UUID,
      platform: PLATFORM
    }, cb)
  },
  signUp (bundle, cb) {
    return doPost(`/user/signup`, {
      ...bundle,
      uuid: DEVICE_UUID,
      platform: PLATFORM
    }, cb)
  },
  phoneSignUp (bundle, cb) {
    console.log(bundle)
    return doPost(`/phone/phoneSignup`, {
      ...bundle,
      uuid: DEVICE_UUID,
      platform: PLATFORM
    }, cb)
  },
  sendPhoneCode (bundle, cb) {
    return doPost(`/phone/identifying`, bundle, cb)
  },
  ssLogin (type, token, cb) {
    const bundle = {
      types: type.toString(),
      ss_token: token.toString(),
      uuid: DEVICE_UUID,
      platform: PLATFORM
    }
    return doPost(`/user/ssLogin`, bundle, cb)
  },
  changeTypeToPhone (bundle) {
    return doPost('/user/changeTypeToPhone', bundle)
  },
  sendChangeToPhoneMail (email) {
    return doPost('/user/sendChangeTypeToPhoneMail', {email})
  },
  ssSignup (type, bundle) {
    return doPost('/user/ssSignup', {
      types: type,
      ...bundle,
      uuid: DEVICE_UUID,
      platform: PLATFORM
    })
  },
  logout () {
    return doPost('/user/logout', {
      uuid: DEVICE_UUID,
      platform: PLATFORM
    })
  },
  getUserInfoByCellphone (cellphone) {
    return doGet(`/phone/info?cellphone=${cellphone}`)
  },
  getFBInfoByEmail (email) {
    return doGet(`/user/fbinfo?email=${email}`)
  },
  getFBInfoByCellphone (cellphone) {
    return doGet(`/user/fbinfo?cellphone=${cellphone}`)
  }
}
